module.exports = __webpack_public_path__ + "media/images/icons/star-half-filled-f8de53bcc94228219e1eadc8e993376a.svg";